<template>
	<v-card 
		class="elevation-8 pt-10 pb-10 pl-5 pr-5" 
		height="480px"
	>
		<v-img 
			height="90" 
			contain 
			src="@/assets/logo.jpeg"
		>
			
		</v-img>
		<v-card-title
			class="font-weight-black justify-center"
		>
			{{form_title}}
		</v-card-title>
		<v-card-subtitle
			class="font-weight-black text-center mt-0"
		>
			{{form_subtitle}}
		</v-card-subtitle>
		<template v-if="is_send === false">
			<v-card-subtitle
				class="black--text text-center mt-0"
			>
				輸入信箱後，立即收信重設密碼。
			</v-card-subtitle>
		
			<v-card-text>
				<v-text-field
					prepend-icon="mdi-email"
					name="login"
					:label="account_label_text"
					type="text"
					v-model="account"
					@keyup.enter="sendEmail"
				></v-text-field>		
			</v-card-text>
			<v-card-actions
				class="justify-center"
			>
				<v-btn
					outlined
					color="#ee5e58"
					class="pl-10 pr-10"
					@click="sendEmail"
				>
					{{form_action_btn_text}}
				</v-btn>
			</v-card-actions>
		</template>

		<template v-else>
			<v-card-subtitle
				class="black--text text-center mt-0"
			>
				{{send_message}}
			</v-card-subtitle>
		</template>
						
	</v-card>
</template>
<script>
import {
	apiSendResetEmail
} from '@/api/admin.js'

	export default {
		name: 'UserForgetPwd',
		components: {
		},
		created: function() {
			this.initPage()
		},
		mounted: function() {
			console.log(process.env.VUE_APP_MODE)
			console.log(process.env.VUE_APP_API_ENDPOINT)
		},
		data: function() {
			return {
				// 登入視窗標題
				form_title: '',

				// 登入視窗副標題
				form_subtitle: '',

				// 帳號的數值
				account: '',

				// 帳號輸入框的標題文字
				account_label_text: '', 

				// 登入按鈕的文字
				form_action_btn_text: '',

				is_send: false,

				send_message: '',
		
			}
		},
		methods: {
			initPage: function() {
				this.form_title           = 'Optimize99'
				this.form_subtitle        = '重設密碼'
				this.account              = ''
				this.account_label_text   = '信箱'
				this.form_action_btn_text = '寄送重設密碼信件'
			},
			sendEmail: async function(){

				if (!this.account) {
					this.$root.vtoast.show({
						message: '請輸入帳號'
					})
					return
				}

                if (!this.$utils.checkEmail(this.account)) {
					this.$root.vtoast.show({
						message: '信箱格式不正確'
					})
                    return
                }

				let param = {
					email: this.account 
				}
				let that = this
				apiSendResetEmail(param).then(function(resp){
					let data = resp.data
					console.log(data)
					that.is_send = true
					that.send_message = `發信成功！請至${that.account}收信重設密碼`
					that.$root.vtoast.show({
						color: 'primary',
						message: `發信成功！請至${that.account}收信重設密碼`
					})

				}).catch(function(error){
					console.error(error)
					that.$root.vtoast.show({
						message: "發送失敗，原因: " + error.response ? error.response.data : error
					})
				})
			}		
		}
	};
</script>
<style>
	
</style>